import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { sendClarityEvent, sendGTMEvent } from "../utils/analytics";
import { LegalTexts } from "./LegalTexts";
import { t } from "../i18n";
import { Icon } from "../components/Icon";

export const PopupCall = (props) => {
	const {
		flow,
		data,
		setData,
		errors,
		openPopUpClientEdit,
		popUpCall,
		closePopUpCall,
		validateForm,
	} = useContext(AppContext);

	const [message, setMessage] = useState(null);
	const [isVisible, setIsVisible] = useState(false);

	const [confirmCall, setConfirmCall] = useState(false);

	const [hasData, setHasData] = useState(false);

	const params = new URLSearchParams(window.location.search);
	const isIframe = params.get("popUpCall");

	const [disabled, setDisabled] = useState(false);

	const requestCall = () => {
		setDisabled(true);
		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
		let token = process.env.REACT_APP_API_TOKEN;

		let controller = new AbortController();
		let options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ...data, token }),
			signal: controller.signal,
		};

		const callEndpoint = () => {
			fetch(`${apiUrl}/call/${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setMessage({
							text: t("Llamada solicitada"),
							color: "green",
						});
						setConfirmCall(true);

						if (!isIframe && popUpCall) {
							sendClarityEvent("fc-tengo-dudas");
							sendGTMEvent("fc-tengo-dudas", {
								origin: data.origin,
								locator: data.locator,
							});
							// add cross-site message to parent window
							window.parent.postMessage(
								{
									type: "tengo-dudas",
									data: {
										origin: data.origin,
										name: data.name,
										phone: data.phone,
										booking: data,
									},
								},
								"*"
							);
						} else {
							sendClarityEvent("fc-callmeback");
							sendGTMEvent("fc-callmeback", {
								origin: data.origin,
								locator: data.locator,
							});
							// add cross-site message to parent window
							window.parent.postMessage(
								{
									type: "llamada-confirmada",
									data: {
										origin: data.origin,
										name: data.name,
										phone: data.phone,
										booking: data,
									},
								},
								"*"
							);
						}
						sessionStorage.removeItem("Data");
					} else {
						setMessage({
							text: t("Error al solicitar la llamada"),
							color: "red",
						});
						if (!isIframe) {
							sendClarityEvent("fc-error-tengo-dudas");
							sendGTMEvent("fc-error-tengo-dudas", {
								origin: data.origin,
								locator: data.locator,
							});
						} else {
							sendClarityEvent("fc-error-callmeback");
							sendGTMEvent("fc-error-callmeback", {
								origin: data.origin,
								locator: data.locator,
							});
						}
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		};

		if (isIframe || !hasData) {
			if (!validateForm()) {
				console.log("Formulario con errores, deteniendo navegación...");
				setDisabled(false);
				return;
			}

			fetch(`${apiUrl}/bookings/${data.locator}`, options)
				.then((res) => res.json())
				.then(() => {
					callEndpoint();
				})
				.catch((err) => {
					console.error(err);
				});
		} else {
			callEndpoint();
		}
	};

	useEffect(() => {
		if (data.name && data.phone) {
			setHasData(true);
		} else {
			setHasData(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (message) {
			setIsVisible(true);

			const timer = setTimeout(() => {
				setIsVisible(false);
				setMessage(null);
			}, 2000);

			return () => clearTimeout(timer);
		}
	}, [message]);

	useEffect(() => {
		if (!isIframe && popUpCall) {
			sendClarityEvent("fc-iniciar-tengo-dudas");
			sendGTMEvent("fc-iniciar-tengo-dudas", {
				origin: data.origin,
				locator: data.locator,
			});
			// add cross-site message to parent window
			window.parent.postMessage(
				{
					type: "iniciar-tengo-dudas",
					data: {
						origin: data.origin,
					},
				},
				"*"
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isIframe, popUpCall]);

	return (
		<div
			className={
				"popup_call kensei_02" +
				(popUpCall ? " isActive" : "") +
				(isIframe ? " isIframe" : "")
			}
		>
			<div className="popup_call_content">
				<button
					onPointerDown={closePopUpCall}
					className={"popup_call_close" + (isIframe ? " hidden" : "")}
				>
					<img
						className="popup_call_icon"
						src="resources/icons/close.svg"
						alt="Cerrar"
					/>
				</button>
				<div
					className={
						"popup_call_body" + (confirmCall ? " hidden" : "")
					}
				>
					<div className="popup_call_header">
						<Icon name="operator" className="popup_operator_img" />
						<h2>{t("¿Tienes dudas?")}</h2>
						<p>
							{t(
								"Atención al Cliente se pondrá en contacto contigo para valorar tu caso y buscar la solución más ágil"
							)}
						</p>
					</div>
					{!isIframe && hasData && (
						<div className="popup_info_client">
							<h2>
								<span>{t("Datos cliente")}</span>
								<button onPointerDown={openPopUpClientEdit}>
									<Icon name="edit" className="client_edit" />
								</button>
							</h2>
							<ul>
								<li>
									<strong>{t("Nombre:")}</strong> {data.name}
								</li>
								<li>
									<strong>{t("Teléfono:")}</strong>{" "}
									{data.phone}
								</li>
								{flow === "mapfre" && (
									<li>
										<strong>{t("Email:")}</strong>{" "}
										{data.email}
									</li>
								)}
							</ul>
						</div>
					)}
					{(isIframe || !hasData) && (
						<div className="popup_client_edit_body">
							<form>
								<label>
									<strong>{t("Nombre y Apellidos")}</strong>
									<input
										type="text"
										defaultValue={data ? data.name : ""}
										onChange={(e) =>
											setData({
												...data,
												name: e.target.value,
											})
										}
									/>
									{errors.name && (
										<span className="error">
											{errors.name}
										</span>
									)}
								</label>
								<label>
									<strong>{t("Teléfono")}</strong>
									<input
										type="tel"
										defaultValue={data ? data.phone : ""}
										onChange={(e) =>
											setData({
												...data,
												phone: e.target.value,
											})
										}
									/>
									{errors.phone && (
										<span className="error">
											{errors.phone}
										</span>
									)}
								</label>
								{flow === "mapfre" && (
									<label>
										<strong>{t("Email")}</strong>
										<input
											type="email"
											defaultValue={
												data ? data.email : ""
											}
											onChange={(e) =>
												setData({
													...data,
													email: e.target.value,
												})
											}
										/>
										{errors.email && (
											<span className="error">
												{errors.email}
											</span>
										)}
									</label>
								)}
							</form>
						</div>
					)}
					{!confirmCall && (
						<span
							className={
								"popup_message kensei_03" +
								(isVisible ? " translate" : "") +
								(isIframe ? " is_iframe" : "") +
								" " +
								(message ? message.color : "")
							}
						>
							{message && message.text}
						</span>
					)}
					<button
						className={
							"nav_next kensei_03" +
							(!data.name || !data.phone || disabled
								? " disabled"
								: "")
						}
						onPointerDown={requestCall}
					>
						<Icon name="phone" className="footer_icon" />
						<p className="footer_p">{t("Solicitar llamada")}</p>
					</button>
					<LegalTexts />
				</div>
				<div
					className={
						"confirm_call_body" + (confirmCall ? " shown" : "")
					}
				>
					<Icon name="send" className="popup_operator_img" />
					<h2>{t("Tu solicitud ha sido enviada")}</h2>
					<p>
						{t(
							"Gracias por contactar con Ralarsa, en unos minutos te llamaremos."
						)}
					</p>
					{!isIframe ||
						(flow !== "mapfre" && (
							<a
								className="confirm_call_button"
								href="https://www.ralarsa.com/es/"
							>
								<p>{t("Volver al inicio")}</p>
								<img
									src="resources/icons/arrow_up_right.svg"
									alt="Regresar a la web de Ralarsa"
								/>
							</a>
						))}
				</div>
			</div>
		</div>
	);
};
